import { FC } from 'react';
import { DynamicComponent } from '../shared/DinamicComponent';
import { mesumoDictionary } from '../../constants/mesumoDictionary';
import { LoadingComponent } from '../shared/LoadingComponent';
import { ErrorComponent } from '../error/ErrorComponent';
import { useHomeData } from './useHomeData';

export const HOME_PATH = '/';

export const Home: FC = () => {
  const [data, isLoading, dataError] = useHomeData();

  if (isLoading) return <LoadingComponent />;

  if (dataError) return <ErrorComponent />;

  return (
    <>
      {data?.modulos.map((module, index: number) => {
        return (
          <DynamicComponent
            key={index}
            dictionary={mesumoDictionary}
            type={module.layout}
            data={module.modulosItems}
            orden={module.orden}
            moduloTitulo={module.moduloTitulo}
            backgroundColor={'secondary.0'}
          />
        );
      })}
    </>
  );
};
